import colorPalette from "../utils/json/colorsPalette.json";

const colors = {
    ...colorPalette,
}
let AppColors = {
    ...colors

}

const setAppColors = (value) => {
    if (value) {
        AppColors = value;
    }
}

// Get computed CSS variable values for colors
const getComputedColor = (cssVariable) => {
    return getComputedStyle(document.documentElement).getPropertyValue(cssVariable).trim();
};

export { AppColors, setAppColors, getComputedColor };